import Vue from 'vue';

import DeleteModal from '../components/modal/DeleteModal';
import ConfirmModal from '../components/modal/ConfirmModal';
import store from '../store';

const modals = {
	confirm:       ConfirmModal,
	confirmDelete: DeleteModal,
};

// TODO: refactor to use app.config.globalProperties after switching to Vue 3
const install = (vueInstance) => {
	for (const [key, modal] of Object.entries(modals)) {
		const instanceKey = `$${key}`;
		vueInstance.prototype[instanceKey] = (props) => {
			return new Promise((resolve, reject) => {
				// init & mount
				const instance = new (Vue.extend(modal))({
					propsData: props,
					store,
				}).$mount();
				document.body.appendChild(instance.$el);

				// handlers
				const close = () => {
					instance.$el.remove();
					instance.$destroy();
				};
				instance.$on('confirm', (value) => {
					close();
					resolve(value);
				});
				instance.$on('cancel', () => {
					close();
					reject(new Error('User cancel.'));
				});
			});
		};
	}
};

export { install };
